import PageLayout from "../../../components/layout/page";
import { DataView } from "../../../components/table/table";
import { useApi } from "../../../helper/apiHook";
import { useAddUpdate } from "../../../helper/addUpdateHook";
import { AddUpdateState } from "./addUpdate";
import { Button } from "reactstrap";
import { plus } from "../../../constant/icons";
import { columns } from "./columns";
import { useEffect } from "react";
import ModalView from "../../../components/modal";

export const StateApi = (paging?:boolean, dataLoad: any = {}) => {
  return useApi("/states",paging, undefined, dataLoad) ;
};

export default function State() {
  const api = StateApi(true);
  // useEffect(() => {
  //   api.mutate();
  // }, []);
  const AddUpdate = useAddUpdate();
  return (
    <>
      <PageLayout
        item={
          <Button
            color="secondary"
            onClick={() =>
              AddUpdate.openAddEditFrom({
                name: "",
              })
            }
          >
            {plus.icon}Add New
          </Button>
        }
        View={
          <>
            <DataView
              columns={columns({api,
                openAddEditFrom: AddUpdate.openAddEditFrom,
              })}
              rows={api.data}
              updatePagination={api.updatePagination}
              currentPage={api.currentPage}
              rowCount={api.rowCount}
              limit={api.limit}
            />
          </>
        }
      />
      {AddUpdate.viewAddUpdate && (
        <ModalView
          modalView={AddUpdate.viewAddUpdate}
          modalName={AddUpdate.currentValue?.id ? "Edit State" : "Add State"}
          onModalDismiss={AddUpdate.closeAddEditFrom}
        >
          <AddUpdateState
            closeAddUpdate={AddUpdate.closeAddEditFrom}
            api={api}
            value={AddUpdate.currentValue}
          />
        </ModalView>
      )}
    </>
  );
}
